var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignTool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BAAAB"
    },
    d: "M505.328,498.2L18.105,10.977c-2.311-2.311-5.791-3.003-8.81-1.752 c-3.021,1.25-4.991,4.2-4.991,7.469v487.223c0,4.466,3.62,8.084,8.084,8.084h487.223c3.27,0,6.217-1.969,7.469-4.991 C508.332,503.989,507.64,500.512,505.328,498.2z M85.149,431.156V192.304l239.676,238.852L85.149,431.156L85.149,431.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#687F82"
    },
    d: "M261.718,254.588l-56.936,56.936l120.044,119.632H85.149L6.673,509.633 c1.463,1.463,3.484,2.368,5.716,2.368h487.223c3.27,0,6.217-1.969,7.469-4.991s0.559-6.498-1.753-8.811L261.718,254.588z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#365558"
    },
    d: "M77.066,461.338c-4.465,0-8.084,3.619-8.084,8.084V512H85.15v-42.578 C85.15,464.958,81.531,461.338,77.066,461.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#365558"
    },
    d: "M141.741,461.338c-4.465,0-8.084,3.619-8.084,8.084V512h16.169v-42.578 C149.826,464.958,146.206,461.338,141.741,461.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#365558"
    },
    d: "M206.417,461.338c-4.465,0-8.084,3.619-8.084,8.084V512h16.169v-42.578 C214.502,464.958,210.882,461.338,206.417,461.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#365558"
    },
    d: "M271.093,461.338c-4.465,0-8.084,3.619-8.084,8.084V512h16.169v-42.578 C279.177,464.958,275.557,461.338,271.093,461.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#365558"
    },
    d: "M335.768,461.338c-4.465,0-8.084,3.619-8.084,8.084V512h16.169v-42.578 C343.853,464.958,340.233,461.338,335.768,461.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#365558"
    },
    d: "M400.444,461.338c-4.465,0-8.084,3.619-8.084,8.084V512h16.169v-42.578 C408.528,464.958,404.909,461.338,400.444,461.338z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M176.234,231.74c-2.069,0-4.138-0.789-5.716-2.367L49.79,108.645c-3.157-3.158-3.157-8.276,0-11.434 c3.157-3.156,8.276-3.156,11.432,0L181.95,217.939c3.157,3.158,3.157,8.276,0,11.434C180.372,230.95,178.304,231.74,176.234,231.74 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M219.351,279.168c-2.069,0-4.138-0.789-5.716-2.367l-21.559-21.559 c-3.157-3.158-3.157-8.276,0-11.434c3.157-3.156,8.276-3.156,11.432,0l21.559,21.559c3.157,3.158,3.157,8.276,0,11.434 C223.489,278.379,221.421,279.168,219.351,279.168z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD6A33"
    },
    d: "M444.352,214.61L257.749,28.007c-1.516-1.516-3.572-2.367-5.716-2.367s-4.201,0.852-5.716,2.367 l-85.367,85.367c-1.517,1.517-2.368,3.572-2.368,5.717c0,2.144,0.852,4.2,2.368,5.717l186.603,186.602 c1.578,1.578,3.648,2.367,5.716,2.367s4.138-0.789,5.716-2.367l85.367-85.366c1.517-1.517,2.368-3.572,2.368-5.717 C446.72,218.182,445.869,216.127,444.352,214.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0353D"
    },
    d: "M203.997,70.326l-43.048,43.048c-1.517,1.517-2.368,3.572-2.368,5.717c0,2.144,0.852,4.2,2.368,5.717 l186.603,186.602c1.578,1.578,3.648,2.367,5.716,2.367c2.069,0,4.138-0.789,5.716-2.367l43.048-43.048L203.997,70.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ACFD9"
    },
    d: "M416.912,242.049L230.309,55.447c-3.157-3.156-8.276-3.156-11.432,0l-30.488,30.488 c-1.517,1.517-2.368,3.572-2.368,5.717c0,2.144,0.852,4.2,2.368,5.717l186.603,186.602c1.578,1.578,3.648,2.367,5.716,2.367 c2.069,0,4.138-0.789,5.716-2.367l30.488-30.488c1.517-1.517,2.368-3.572,2.368-5.717 C419.281,245.621,418.429,243.565,416.912,242.049z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0295AA"
    },
    d: "M203.997,70.326l-15.608,15.608c-1.517,1.517-2.368,3.572-2.368,5.717c0,2.144,0.852,4.2,2.368,5.717 l186.603,186.602c1.578,1.578,3.648,2.367,5.716,2.367c2.069,0,4.138-0.789,5.716-2.367l15.608-15.608L203.997,70.326z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD1A9"
    },
    d: "M139.607,6.665c-1.911,1.911-2.741,4.651-2.211,7.302l21.342,106.709l94.88-94.88L146.909,4.454 C144.258,3.923,141.518,4.753,139.607,6.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD1A9"
    },
    d: "M139.994,6.324c-0.129,0.113-0.264,0.219-0.387,0.342c-1.911,1.911-2.741,4.651-2.211,7.302 l21.342,106.709l47.805-47.805L139.994,6.324z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#687F82"
    },
    d: "M139.607,6.665c-1.911,1.911-2.741,4.651-2.211,7.302l9.146,45.733l46.099-46.1l-45.732-9.146 C144.258,3.923,141.518,4.753,139.607,6.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#365558"
    },
    d: "M139.994,6.324c-0.129,0.113-0.264,0.219-0.387,0.342c-1.911,1.911-2.741,4.651-2.211,7.302 l9.146,45.733l23.414-23.415L139.994,6.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD4D5"
    },
    d: "M444.352,214.61l-96.801,96.801l60.977,60.976c1.578,1.578,3.648,2.367,5.716,2.367 s4.138-0.789,5.716-2.367l85.367-85.366c1.517-1.517,2.368-3.573,2.368-5.717s-0.852-4.2-2.368-5.717L444.352,214.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BAAAB"
    },
    d: "M396.316,262.646l-48.765,48.765l60.977,60.976c1.578,1.578,3.648,2.367,5.716,2.367 s4.138-0.789,5.716-2.367l43.048-43.048L396.316,262.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M456.495,292.103c-2.069,0-4.138-0.789-5.716-2.367l-21.559-21.559 c-3.157-3.158-3.157-8.276,0-11.434c3.157-3.156,8.276-3.156,11.432,0l21.559,21.559c3.157,3.158,3.157,8.276,0,11.434 C460.633,291.314,458.565,292.103,456.495,292.103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ACFD9"
    },
    d: "M505.328,100.133L413.863,8.667c-11.558-11.556-30.363-11.555-41.922,0l-27.44,27.44 c-11.558,11.559-11.558,30.364,0,41.923l91.464,91.466c1.516,1.516,3.572,2.367,5.716,2.367c2.144,0,4.201-0.852,5.716-2.367 l57.928-57.928C508.487,108.409,508.487,103.291,505.328,100.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD1A9"
    },
    d: "M441.684,171.863c2.144,0,4.201-0.852,5.716-2.367l57.928-57.928c3.157-3.158,3.157-8.276,0-11.434 l-60.976-60.976l-69.361,69.361l60.976,60.977C437.484,171.011,439.54,171.863,441.684,171.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0295AA"
    },
    d: "M358.465,22.144l-13.962,13.962c-11.558,11.559-11.558,30.364,0,41.923l91.464,91.466 c1.516,1.516,3.572,2.367,5.716,2.367s4.201-0.852,5.716-2.367l29.208-29.208L358.465,22.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8C29"
    },
    d: "M409.914,73.594l-34.924,34.924l60.976,60.977c1.516,1.516,3.572,2.367,5.716,2.367 s4.201-0.852,5.716-2.367l29.208-29.208L409.914,73.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M463.026,113.934c-2.069,0-4.138-0.789-5.716-2.367l-24.39-24.391c-3.157-3.158-3.157-8.276,0-11.434 c3.157-3.156,8.276-3.156,11.432,0l24.39,24.391c3.157,3.158,3.157,8.276,0,11.434C467.164,113.145,465.095,113.934,463.026,113.934 z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignTool);
export default __webpack_public_path__ + "static/media/design-tool.a7d6dbc6ed8769e658f468d380e9525a.svg";
export { ForwardRef as ReactComponent };